module.exports = __webpack_public_path__ + "dimension.png?88d2210113291b83fe7a9dcba1310185";


//////////////////
// WEBPACK FOOTER
// ./static/images/dimension.png
// module id = 19
// module chunks = 0 1